/**
 * SubscriptionBadge — a small "Pro" / "Pro+" chip in the nav for subscribers.
 * Free users see no badge (explicit spec — do NOT render a "Free" label).
 * Clicking the badge routes to /account (subscribers manage from there).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const SubscriptionBadge = ({ compact = false }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const tier = user?.tier;
  if (tier !== 'pro' && tier !== 'pro_plus') return null;
  const label = tier === 'pro_plus' ? 'Pro+' : 'Pro';
  // Use a non-button element so it can safely nest inside the "My Account" <button>
  // in SiteNav/LandingPage. Clicks bubble up to the parent, which navigates to /account —
  // exact behaviour we want for subscribers. For non-nested callers, clicking the chip
  // itself still lands on /account.
  const handleClick = (e) => {
    e.stopPropagation();
    navigate('/account');
  };
  const handleKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick(e);
    }
  };
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKey}
      data-testid={`subscription-badge-${tier}`}
      title={`${label} subscriber — manage subscription`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: tier === 'pro_plus' ? '#2563EB' : '#0F2742',
        color: '#fff',
        fontSize: compact ? 9 : 10,
        fontWeight: 800,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        padding: compact ? '2px 7px' : '3px 9px',
        borderRadius: 999,
        cursor: 'pointer',
        marginLeft: compact ? 4 : 6,
        lineHeight: 1.2,
        userSelect: 'none',
      }}
    >
      {label}
    </span>
  );
};

export default SubscriptionBadge;
